import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import React from 'react'
import { Formik } from 'formik'
import DeleteProfileForm from './DeleteProfileForm'
import useModals from 'src/Hooks/useModals'
import { useDeleteProfileFormInitializer } from 'src/Libs/user/hooks'
import { isFlowTheme } from 'src/Libs/utils'

export interface DeleteProfileProps {
  onClose: () => void
  place: number
}

/**
 * Dialogs which asks the user to confirm that his/her accounts should be deleted
 */
const DeleteProfileDialog: React.VFC<DeleteProfileProps> = ({ onClose, place }) => {
  const { t } = useCustomTranslation() // keep translation subscription for runtime language changes
  const { openDeleteProfileSurveyDialog } = useModals()
  const { initialValues, validationSchema } = useDeleteProfileFormInitializer()

  const handleDeleteUserAccount = (): void => {
    const url = t('user.userProfile.dialog.delete-url')
    const sanitizedUrl = url.replaceAll(/[\u200B-\u200D\uFEFF]/g, '').trim()
    window.open(sanitizedUrl, '_self')
  }

  const primaryAction = async (): Promise<void> => {
    if (isFlowTheme) {
      handleDeleteUserAccount()
      return
    }

    openDeleteProfileSurveyDialog()
  }

  return (
    <Formik initialValues={initialValues} onSubmit={primaryAction} validationSchema={validationSchema} validateOnMount>
      {({ isValid, handleSubmit }) => {
        return (
          <Dialog
            title={t('user.userProfile.dialog.title')}
            actions={{
              primary: {
                name: t('common.next'),
                onClick: handleSubmit,
                disabled: !isValid,
              },
              secondary: {
                name: t('common.cancel'),
                onClick: onClose,
              },
            }}
            onClose={onClose}
            maxWidth="sm"
          >
            <DeleteProfileForm />
          </Dialog>
        )
      }}
    </Formik>
  )
}

export default DeleteProfileDialog
